import { useTryCallApi } from 'common/hooks/use-try-call-api'
import { AssetLedger } from 'common/models'
import { AssetsSuggestionsService, PresenterSuggestAssetCategoryResponse } from 'common/open-api'
import { useFormikContext } from 'formik'
import get from 'lodash/get'
import { useCallback, useEffect, useState } from 'react'

import { useGetAssetCategory } from './use-get-asset-category'

export type File = {
  id: number
  filename: string
  thumbnail_url: string
  url: string
}

export const useAISuggestion = () => {
  const { assetCategoryList } = useGetAssetCategory()

  const { setFieldValue, values } = useFormikContext()
  const [assetName, setAssetName] = useState<string | undefined>(undefined)
  const [image, setImage] = useState<File | undefined>(undefined)
  const { data, callApi, isLoading } = useTryCallApi(AssetsSuggestionsService.suggestionsCreate)
  const [responseData, setResponseData] = useState<PresenterSuggestAssetCategoryResponse | undefined>()
  const fixedAssetLedgers: AssetLedger[] = get(values, 'fixed_asset_ledgers')

  useEffect(() => {
    if (data) {
      setResponseData(data?.data)
    }
  }, [data])

  const onSubmit = useCallback(
    async (image?: File) => {
      setImage(image)

      const payload = image ? { file_id: image.id.toString() } : { asset_name: assetName }
      await callApi(payload)
    },
    [assetName]
  )

  const onTryAgain = () => {
    setResponseData(undefined)
    setAssetName(undefined)
    setImage(undefined)
  }

  const onReflect = () => {
    const assetCategoryInfo = assetCategoryList.find(item => item.code === responseData?.asset_category_code)
    setFieldValue('asset_category_id', { value: assetCategoryInfo?.id, label: assetCategoryInfo?.name })

    for (let i = 0; i < fixedAssetLedgers?.length; i++) {
      setFieldValue(`fixed_asset_ledgers[${i}].service_life`, responseData?.service_life)
    }
  }

  return {
    image,
    onSubmit,
    assetName,
    setAssetName,
    responseData,
    isLoading,
    onTryAgain,
    onReflect,
  }
}
